import React, { FC } from 'react';
import { ReactComponent as Hierarchy } from '../../../assets/MainMenu/Hierarchy.svg';

export const HierarchyIcon: FC = () => <Hierarchy />;
